import React, { FunctionComponent, ReactElement } from 'react';
import { Box } from '@rebass/emotion';
import { rem } from '@app/styles/theme/layout';
import { isTruthy } from '@app/helpers/predicate';

import { Title, ContentBlockInnerHTML } from './styles';

interface ContentBlockProps {
  title: string;
  innerHtml?: string | string[];
  children?: ReactElement[];
  width?: string | Array<string>;
}

const ContentBlock: FunctionComponent<ContentBlockProps> = ({
  title,
  innerHtml = [],
  children,
  ...props
}) => {
  const htmlContent: string[] = Array.isArray(innerHtml)
    ? innerHtml
    : Array(innerHtml);

  return (
    <Box mb={rem(60)} {...props}>
      <Title data-testid="content-block-title">{title}</Title>

      {htmlContent.length > 0 &&
        htmlContent
          .filter(isTruthy)
          .map((content, index) => (
            <ContentBlockInnerHTML
              key={index}
              data-testid={`content-block-inner-html-${index}`}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ))}

      {children}
    </Box>
  );
};

export default ContentBlock;
